module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_86-c35eba9879f682e42023af19e9b57b20.png";